
import "core-js"
import "regenerator-runtime/runtime"
import router from '~/router/router'
import ELEMENT from 'element-ui'
// import VForm from 'vform-builds'
import AuthRoute from 'plugins/auth-route'
import icUtils from 'plugins/ic-utils'
import apis from '~/common/api'
import Sock from 'plugins/sockjs'
import 'plugins/drag'
import apolloProvider from "./apollo"
import store from './store/index'
import App from '~/pages/index'
import '~/common/assets/css/theme.css'
import '~/common/assets/css/main.css'
// import 'vform-builds/dist/VFormDesigner.css'
import SvgIcon from '~/common/components/custom/SvgIcon'
import  'plugins/dragRange' 
// import '~/common/static/ueditor/ueditor.config.js'
// import '~/common/static/ueditor/ueditor.all.min.js'
// import '~/common/static/ueditor/lang/zh-cn/zh-cn.js'
// import '~/common/static/ueditor/themes/default/css/ueditor.min.css'
import '~/common/static/luckySheet/plugins/css/pluginsCss.css'
import '~/common/static/luckySheet/plugins/plugins.css'
import '~/common/static/luckySheet/css/luckysheet.css'
import '~/common/static/luckySheet/assets/iconfont/iconfont.css'
// import '~/common/static/ueditor/ueditor.parse.js'
import rulesMarked from '~/common/utils/markedWords.js'
import apolloRequest from '~/common/utils/apolloRequest'
import ClientOnly from '~/common/components/ClientOnly'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import '~/common/assets/less/common.less'
import Print from 'vue-print-nb'
import Inject from '~/common/plugins/inject.js'; // 全局挂载文件，需要挂进Vue.prototype中的在此文件中注入
import Payment from '~/common/plugins/payment.js';
import PromisePayComponent from '~/common/plugins/promisePay.js';
import i18n from '~/common/plugins/i18n.js';
import 'plugins/track'
import { storage } from '~/common/utils/storage';
const req = require.context('~/common/assets/icons/svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
if (module.hot) {
  module.hot.accept(['./main.js'])
}
window.jQuery = $
Vue.use(ELEMENT,{
  i18n: (key, value) => i18n.t(key, value)
})
// Vue.use(VForm)
Vue.use(AuthRoute)
Vue.use(icUtils)
Vue.use(Sock)
Vue.use(VueVirtualScroller)
Vue.use(Print);
Vue.use(Payment);
Vue.use(PromisePayComponent);
Vue.prototype.$nuxt = {
  '$loading': {
    start() {},
    finish() {}
  }
}

for(let k in rulesMarked) {
  Vue.prototype[k] = rulesMarked[k]
}
Vue.prototype.list_size = 50
Vue.prototype.tab_size = 10
Vue.prototype.$apis = apis
Vue.prototype.$apolloRequest = apolloRequest
Vue.component('svg-icon', SvgIcon)
//兼容nuxt中client-only组件
Vue.component('client-only', ClientOnly)
// 全局挂载
Vue.use(Inject);

Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});

const res = new Vue({
  router,
  store,
  i18n,
  apolloProvider,
  render: (h) => h(App)
}).$mount('#app')
export default res
